module.exports = __webpack_public_path__ + "img/header-navigation-below-chevy.0deaca33.png";